/** @description always include jQuery in this manner in every file where jQuery is used */
import '@chenfengyuan/datepicker/dist/datepicker';

const $ = jQuery.noConflict();

'use strict';
const SearchFilterDate = {
	/**
	 * @description Cache dom and strings
	 * @description Please always define selectors, classes and data attributes with the following prefixes
	 * @type {object}
	 * @param {jQuery} $dom	for any jQuery selectors
	 * @param {string} class for any class strings
	 * @param {string} attr for any data attributes strings
	 */

	/**
	 * @description Initialize
	 * @example this.someFunction();
	 */
	init: function() {

		$('[data-toggle="datepicker"]').datepicker({
			format: 'mm/dd/yyyy'
		});

		$('[data-toggle="datepicker2"]').datepicker({
			format: 'mm/dd/yyyy'
		});
	},
};

export default SearchFilterDate;
